"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePortfolioFilterTranslation = void 0;
const typings_1 = require("../../typings");
const client_1 = require("@apollo/client");
const react_1 = require("@apollo/client/react");
const React = require("react");
const SearchResultTranslationService_1 = require("../../services/SearchResultTranslationService");
const ENGLISH_LANGUAGE_CODE = 'en';
const GET_FILTER_TRANSLATIONS = (0, client_1.gql) `
  query getFilterTranslations(
    $isAssetType: Boolean!
    $isDocument: Boolean!
    $isDrawings: Boolean!
    $isSoftwares: Boolean!
  ) {
    cfhsMetadata @include(if: $isAssetType) {
      name
      slug
    }

    assetsMetadata @include(if: $isAssetType) {
      documents @include(if: $isDocument) {
        name
        slug
      }
      drawings @include(if: $isDrawings) {
        name
        slug
      }
      softwares @include(if: $isSoftwares) {
        name
        slug
      }
      softwareCharacteristics @include(if: $isSoftwares) {
        id
        name
      }
    }
  }
`;
const usePortfolioFilterTranslation = (selectedTab, language) => {
    const [isFilterTranslationsLoading, setIsFilterTranslationsLoading] = React.useState(true);
    const shouldSkipQuery = language === ENGLISH_LANGUAGE_CODE && selectedTab.assetsKey !== typings_1.SearchResultAssetKey.Softwares;
    const { data, loading } = (0, react_1.useQuery)(GET_FILTER_TRANSLATIONS, {
        variables: {
            isAssetType: selectedTab.source === 'assets',
            isDocument: selectedTab.assetsKey === typings_1.SearchResultAssetKey.Documents,
            isDrawings: selectedTab.assetsKey === typings_1.SearchResultAssetKey.Drawings,
            isSoftwares: selectedTab.assetsKey === typings_1.SearchResultAssetKey.Softwares,
        },
        skip: shouldSkipQuery,
    });
    React.useEffect(() => {
        setIsFilterTranslationsLoading(loading);
    }, [loading]);
    const hierarchyDictionary = React.useMemo(() => {
        if (data === null || data === void 0 ? void 0 : data.cfhsMetadata) {
            return SearchResultTranslationService_1.searchResultTranslationService.transformToDictionary(data === null || data === void 0 ? void 0 : data.cfhsMetadata);
        }
        if (data === null || data === void 0 ? void 0 : data.cfhsByLevel) {
            return SearchResultTranslationService_1.searchResultTranslationService.transformToDictionary(data === null || data === void 0 ? void 0 : data.cfhsByLevel);
        }
        return {};
    }, [data]);
    const assetsDictionary = React.useMemo(() => {
        var _a;
        return SearchResultTranslationService_1.searchResultTranslationService.transformToDictionary((_a = data === null || data === void 0 ? void 0 : data.assetsMetadata) === null || _a === void 0 ? void 0 : _a[selectedTab.assetsKey]);
    }, [data, selectedTab.assetsKey]);
    const softwareCharacteristicsDictionary = React.useMemo(() => {
        var _a;
        return SearchResultTranslationService_1.searchResultTranslationService.transformToDictionary((_a = data === null || data === void 0 ? void 0 : data.assetsMetadata) === null || _a === void 0 ? void 0 : _a.softwareCharacteristics, 'id');
    }, [data, selectedTab.assetsKey]);
    if (shouldSkipQuery) {
        return {
            filterDictionary: {},
            isFilterTranslationsLoading: false,
        };
    }
    return {
        filterDictionary: Object.assign(Object.assign(Object.assign({}, hierarchyDictionary), assetsDictionary), softwareCharacteristicsDictionary),
        isFilterTranslationsLoading,
    };
};
exports.usePortfolioFilterTranslation = usePortfolioFilterTranslation;
